import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'
import {useFormContext} from 'react-hook-form'

import {type DrawerProps, Drawer} from '../../../../components/mobile'
import {useConfigContext} from '../../../../contexts'
import {Suggest} from '../Suggest/Suggest'

type SuggestDrawerProps = Pick<DrawerProps, 'onClose' | 'opened'> & {
  isSource: boolean
  name: string
}

export const SuggestDrawer = ({isSource, name, onClose, opened}: SuggestDrawerProps): ReactElement => {
  const i18n = useI18n()
  const {location} = useConfigContext()
  const addressPin = useFormContext().watch(name)

  const label = isSource ? i18n('bdui.address.input.from', 'Откуда') : i18n('bdui.address.input.to', 'Куда')

  return (
    <Drawer onClose={onClose} opened={opened} fullScreen>
      <Drawer.Body>
        <Suggest
          addressPin={addressPin}
          coordinates={location}
          isSource={isSource}
          label={label}
          name={name}
          onClose={onClose}
        />
      </Drawer.Body>
    </Drawer>
  )
}
